import { LoadStatusChangedEvent } from '@rematter/frontend-lib-api-client/grpc/trade/load_events_pb';
import { LoadStatus } from '@rematter/frontend-lib-api-client/grpc/trade/load_pb';
import { Col, FieldDisplay, IDField, StatusTransition } from '@rematter/ui-web';

import { loadStatusLabels } from '../enumLabels';

import { useTranslations } from '~/modules/trade/i18n/useTranslations';

type LoadStatusChangedDetailProps = {
  event: LoadStatusChangedEvent;
};

export const LoadStatusChangedDetail = ({
  event,
}: LoadStatusChangedDetailProps) => {
  const t = useTranslations();
  const load = event.load;

  if (!load) {
    return (
      <Col className="@LoadStatusChangedDetail items-center justify-center p-4 text-neutral/40">
        <span>{t.eventLogs.noDataAvailable}</span>
      </Col>
    );
  }

  return (
    <Col className="@LoadStatusChangedDetail gap-3" gap3>
      <Col className="rounded-md border border-neutral/10 bg-white p-3" gap2>
        <span className="text-xs font-medium text-neutral/60">
          {t.eventLogs.load.sectionTitle}
        </span>
        <div className="grid grid-cols-2 gap-x-4 gap-y-1">
          <IDField label="ID" value={load.id} />
          <FieldDisplay
            label={t.eventLogs.load.documentNumber}
            value={String(load.documentNumber)}
          />
        </div>
      </Col>

      <Col className="rounded-md border border-neutral/10 bg-white p-3" gap1>
        <span className="mb-2 text-xs font-medium text-neutral/60">
          {t.eventLogs.load.statusChange}
        </span>
        <StatusTransition
          previousStatus={
            loadStatusLabels[event.previousStatus as LoadStatus] ??
            `Unknown (${event.previousStatus})`
          }
          newStatus={
            loadStatusLabels[event.newStatus as LoadStatus] ??
            `Unknown (${event.newStatus})`
          }
        />
      </Col>
    </Col>
  );
};
